import { ContainerType, Workflow } from '@apiContract';

export const getContainerTypeIdByWorkflow = (
  containerTypes: ContainerType[],
  workflow: Workflow,
): number => containerTypes.find((ct) => ct.workflow === workflow)?.id || 0;
